import React from 'react';
import { IconProps } from './types';

const ArrowBottom2: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size * 1.5625}
    height={size}
    viewBox="0 0 50 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M1.9 2v0c2.65-2.65 6.85-2.65 9.6 0l13.5 13.45 13.45-13.45c2.65-2.65 6.9-2.65 9.65 0v0c2.65 2.65 2.65 6.9 0 9.65l-18.2 18.3c-1.4 1.35-3.050 2.050-4.9 2.050-1.7 0-3.55-0.7-4.85-2.050l-18.25-18.15c-2.55-2.75-2.55-7.15 0-9.8z"
    />
  </svg>
);

export default ArrowBottom2;
